<!-- eslint-disable vue/no-v-html -->
<template>
  <Modal
    class="scoped"
    :modal-style="{ width: '800px' }"
    title="Edit Radio Clips"
  >
    <QCardSection style="font-size: 16px">
      Edit the syndicated radio clips, only clips that are manually edited will
      be changed.
    </QCardSection>
    <QCardSection>
      <div
        v-for="(syndication, index) in syndications"
        :key="syndication.id"
      >
        <RadioClipTextEdit
          v-model="syndications[index]"
          :keywords="keywords"
          @update:model-value="itemUpdate"
        />
      </div>
    </QCardSection>
    <div class="row fixed-bottom sticky-card q-py-sm justify-center">
      <QBtn
        label="Cancel"
        style="margin-right: 10px"
        @click="closeModal"
      />
      <QBtn
        color="black"
        :disabled="!itemIds.length"
        label="Save"
        @click="save"
      />
    </div>
  </Modal>
</template>

<script>
import { uniq } from "lodash-es";
import { Notify } from "quasar";

import Modal from "shared/components/core/modals/Modal.vue";

import RadioClipTextEdit from "src/components/radio/RadioClipTextEdit.vue";

export default {
  name: "RadioClipTextEditModal",
  components: {
    Modal,
    RadioClipTextEdit,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    highlightedText: {
      type: String,
      required: true,
    },
    updatedItemIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["updated"],
  data() {
    return {
      syndications: [],
      keywords: [],
      itemIds: this.updatedItemIds,
    };
  },
  mounted() {
    this.keywords = this.highlightedKeywords(this.highlightedText);

    this.syndications = [
      this.item,
      ...this.item.syndications.filter(
        (syndication) => syndication.is_original === true
      ),
    ];
  },
  methods: {
    closeModal() {
      this.$modals.close("RadioClipTextEditModal");
    },
    async save() {
      const syndicationsToUpdate = uniq(this.itemIds).map((id) =>
        this.syndications.find((syndication) => syndication.id === id)
      );

      try {
        const syndicationsUpdate = syndicationsToUpdate.map(({ id, text }) =>
          this.$streemApiAdmin.put(`radio_clips/${id}`, {
            params: {
              text: text.replace(/<\/?em>/g, ""),
              reprocess_mention_reviews: true,
            },
          })
        );

        await Promise.all(syndicationsUpdate);

        this.closeModal();

        this.$q.dialog({
          title:
            "Radio clips for the following radio stations have been updated:",
          persistent: true,
          ok: "Done",
          html: true,
          message: syndicationsToUpdate
            .map(
              (syndication) =>
                `${syndication.source.name} ${syndication.source.location}`
            )
            .join("<br>"),
        });

        this.$emit("updated");
      } catch {
        Notify.create({
          message: "There was an error updating radio clips.",
          color: "red",
        });
      }
    },
    highlightedKeywords(text) {
      if (text.match(/<em>(.+?)<\/em>/g) === null) return [];

      return text
        .match(/<em>(.+?)<\/em>/g)
        .map((match) => match.replace(/<\/?em>/g, ""));
    },
    itemUpdate(item) {
      this.itemIds.push(item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.scoped :deep(.streem-modal .container) {
  max-width: 100%;
}

.sticky-card {
  position: sticky;
  bottom: 0;
  background-color: white;
}
</style>
